import { NgModule } from '@angular/core';
import { NetStatusService } from './net-status.service';

@NgModule({
  providers: [NetStatusService]
})
export class NetStatusModule { }
